import { useNavigate, useLocation } from 'react-router-dom';

import { Alert, Stack, Tooltip, IconButton } from '@mui/material';
import ArrowForwardRoundedIcon from '@mui/icons-material/ArrowForwardRounded';
import { useTheme } from '@mui/material/styles';

export default function SignContractAlert({ unsignedContracts, callbackUrl }) {
    const theme = useTheme();
    const navigate = useNavigate();
    const { state } = useLocation();

    return unsignedContracts.some((c) => c) ? (
        <Alert
            severity="info"
            sx={{
                padding: 0,
                alignItems: 'center',
                '& .MuiAlert-icon': { padding: '13px 0px 13px 16px' }
            }}
        >
            <Stack direction="row" spacing={0.1} alignItems="center" sx={{ lineHeight: 0 }}>
                <span>Please sign contract before editing session</span>
                <Tooltip title="Contracts">
                    <IconButton onClick={() => navigate('/contracts', { state: { callbackUrl, parentCallbackUrl: state?.callbackUrl } })}>
                        <ArrowForwardRoundedIcon sx={{ color: theme.palette.info.main, fontSize: 20 }} />
                    </IconButton>
                </Tooltip>
            </Stack>
        </Alert>
    ) : (
        <Alert severity="info">Provider must sign contract before session can be edited</Alert>
    );
}
